// @flow
import createMaybeTransform from 'app/common/react/components/closeup/utils/createMaybeTransform';
import type { MaybeAToMaybeAB, HasRecipe } from 'app/common/react/components/closeup/utils/types';

type HasCategorizedIngredients = {
  categorizedIngredients: any,
};

type ToMaybeHasCategorizedIngredients = MaybeAToMaybeAB<HasRecipe, HasCategorizedIngredients>;

const hasCategorizedIngredients: ToMaybeHasCategorizedIngredients = createMaybeTransform(
  (props) => {
    const { categorizedIngredients } = props.recipe;
    return categorizedIngredients && categorizedIngredients.length > 0
      ? { ...props, categorizedIngredients }
      : null;
  },
);

export default hasCategorizedIngredients;
